

















































































































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { NewsApi } from "@/api/newsApi";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class NewsSection extends Vue {
  optionList1: Array<object> = [];
  optionList2: Array<object> = [];
  weekHots: Array<object> = [];
  monthHots: Array<object> = [];
  latelyNews: Array<object> = [];
  banner: object = {};
  newsApi = new NewsApi();

  mounted() {
    this.newsApi.getOptionsSection().then((res) => {
      this.optionList1 = res.data.optionList1;
      this.optionList2 = res.data.optionList2;
      this.weekHots = res.data.weekHots;
      this.monthHots = res.data.monthHots;
      this.latelyNews = res.data.latelyNews;
      this.banner = res.data.banner;
    });
  }
}
